import Icon from '@mdi/react'
import styled from 'styled-components'
import theme from 'theme_'

export const StyledRequestSysAccess = styled.div`
  display: flex;
  align-items: center;
  margin: ${theme.spacing.s} 0;

  @media ${theme.devices.desktop} {
    margin: 0 0 ${theme.spacing.md} ${theme.spacing.s};
  }
`

export const RequestSysAccessIcon = styled(Icon)`
  flex: none;
  color: ${theme.colors.horizonOrange};
  margin-right: ${theme.spacing.xs};
`
